/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type {
  InputDescription,
  CheckboxEditorDescription_LabelDescription,
} from "@smartsuite/automation-engine-api";
import { Checkbox } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { CaptionBlock } from "../../../../../../../../components/CaptionBlock";
import { t } from "i18next";
import type { InputCandidate } from "../../../../../../../../types/candidate";
import { StyledContainerWrapper } from "../../../style";
import { StyledCheckboxDescription, StyledCheckboxSection } from "./style";
import { valueConfigVToBool } from "@smartsuite/automation-conditions";
import { translateIfPresent } from "../../../../../../../../locales/i18n";

export const CheckboxEditor = observer<{
  input: InputCandidate;
  onChange: (input: InputCandidate) => void;
  onClickTrash?: () => void;
  description?: InputDescription;
}>(({ description, onClickTrash, input, onChange }) => {
  const [checked, setChecked] = useState<boolean>(false);
  let labelDescription: CheckboxEditorDescription_LabelDescription | undefined;

  if (description?.editor?.editor.oneofKind === "checkbox") {
    labelDescription = description.editor.editor.checkbox.labelDescription;
  }

  useEffect(() => {
    if (input.value?.values[0]) {
      setChecked(valueConfigVToBool(input.value?.values[0]));
    }
  }, [input.value]);

  return (
    <StyledContainerWrapper>
      {description !== undefined && (
        <CaptionBlock description={description} onClickTrash={onClickTrash} />
      )}
      <StyledCheckboxSection>
        <Checkbox
          checked={checked}
          onChange={(checked: boolean) => {
            onChange({
              ...input,
              value: {
                values: [
                  {
                    value: {
                      oneofKind: "bool",
                      bool: checked,
                    },
                  },
                ],
              },
            });
          }}
        />
        <StyledCheckboxDescription>
          {checked
            ? (translateIfPresent(
                `caption.${labelDescription?.enabled ?? ""}`,
                labelDescription?.enabled ?? "",
              ) ?? t("automation-form.enabled"))
            : (translateIfPresent(
                `caption.${labelDescription?.disabled ?? ""}`,
                labelDescription?.disabled ?? "",
              ) ?? t("automation-form.disabled"))}
        </StyledCheckboxDescription>
      </StyledCheckboxSection>
    </StyledContainerWrapper>
  );
});
